module.exports = __webpack_public_path__ + "static/media/multiamarillo75.41629289.gif";